import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import parse from "html-react-parser";
import { getSelectedBrandPath, getSelectedCategoryPath } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCatalogPageStateByPath } from "@insite/client-framework/Store/Data/CatalogPages/CatalogPagesSelectors";
//import { getCatalogPageStateByPath } from "@NA/Store/Data/CatalogPages/CatalogPagesSelectors";
import { getCategoryState } from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { TypographyProps } from "@insite/mobius/Typography";
import { Typography } from "@insite/mobius/index";
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";

import { FC, useEffect } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { css } from "styled-components";
import { getBrandCategoriesDataView } from "@insite/client-framework/Store/Data/Brands/BrandsSelectors";
import { getBrandById } from "@insite/client-framework/Services/BrandService";
import React, { useState } from "react";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import { CoveoActions } from "@NA/Store/Reducer/CoveoCommerceReducer";

const mapStateToProps = (state: ApplicationState) => {
    const location = getLocation(state);
    const selectedCategoryPath = getSelectedCategoryPath(state);
    const path =
        selectedCategoryPath || (location.pathname.toLowerCase().startsWith("/content/") ? "" : location.pathname);
    const catalogPage = getCatalogPageStateByPath(state, path).value;
    return {
        category: getCategoryState(state, catalogPage?.categoryIdWithBrandId ?? catalogPage?.categoryId).value,
        isPLPLoading: state.pages.productList.isLoading,
        catalogPage,
    };
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export interface CategoryDescInterface {
    container?: InjectableCss;
}

export const categoryDescStyles: CategoryDescInterface = {
    container: {
        css: css`
            p {
                font-size: 16px;
                margin: 10px 0 0 0;
                color: #000;
                line-height: 24px;
            }
        `,
    },
};

const styles = categoryDescStyles;

export const ADICategoryDescription: FC<Props> = ({ category, isPLPLoading, catalogPage }) => {
     const dispatch = useDispatch();
    const [HTMLData, setHTMLData] = useState("");
    const [isPLPLoaded, setPLPloading] = useState(false);
    const brandId = catalogPage?.brandId;
    const isLoaded = useSelector(
            (state: CustomApplicationState) => state.ADIGlobalData.coveoCommerce.loadedCompletePLP,
        );

    const fetchBrandData = async () => {
        try {
            const brandData = await getBrandById({
                brandId: brandId ? brandId : "",
                expand: ["htmlContent"],
                additionalExpands: [],
            });
            if (brandData) {
                setHTMLData(brandData?.htmlContent || "");
            }
        } catch (err) {
            console.error("Error fetching brand data:", err);
        }
    };

    React.useEffect(() => {
        if (!brandId) return;
        fetchBrandData();
    }, [brandId]);

      React.useEffect(() => {
        setPLPloading(isLoaded);
    }, [isLoaded]);



    // function to getbrand html async and await

    if (HTMLData && isPLPLoaded && brandId) {
        return <StyledWrapper {...styles.container}>{parse(HTMLData, parserOptions)}</StyledWrapper>;
    }

    if (isPLPLoading) {
        return null;
    }

    
    return (
     <>
      {isPLPLoaded && category && category.htmlContent && (
    <StyledWrapper 
        {...styles.container}>{parse(category.htmlContent, parserOptions)}
    </StyledWrapper>
      )}
    </>
    )
    

};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(ADICategoryDescription),
    definition: {
        group: "Basic",
        icon: "Image",
        displayName: "Product List Category Description",
        fieldDefinitions: [],
    },
};
export default widgetModule;

